import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { Element } from 'react-scroll'
import { useRouter } from 'next/router'

import useViewport from 'contexts/viewport'
import Dropdown from 'components/atomic/dropdown'
import ProjectMoon from './project-moon'
import VisorCortexDatabase from './visor-cortex-database'
import tabStyles from 'styles/tab.module.scss'
import FounderBuild from './founder-build'

export default function Database() {
  const router = useRouter()
  const { tab } = router.query
  const { isMobile } = useViewport()
  const [tabActive, setTabActive] = useState({ key: 'deadrop_founder_builds', value: 'Deadrop Founder Builds' })

  useEffect(() => {
    if (tab === 'snapshots') {
      setTabActive({ key: 'project_moon_build', value: 'Deadrop Snapshots' })
    }
  }, [tab])

  const tabItems = [
    { key: 'visor_cortex_db', value: 'Visor Cortex Database' },
    { key: 'deadrop_founder_builds', value: 'Deadrop Founder Builds' },
    { key: 'project_moon_build', value: 'Deadrop Snapshots' },
  ]

  const selectTab = (connection) => {
    setTabActive(connection)
  }

  return (
    <Element name="snapshots">
      <div className="mb-24 mt-12 max-w-none px-5 sm:mx-0 sm:mt-0 sm:px-9 lg:px-[70px] xl:mx-auto xl:max-w-7xl xl:px-0">
        {isMobile && (
          <Dropdown
            className="mb-8 sm:mb-16"
            label={''}
            items={tabItems}
            defaultValue={tabActive.value}
            onSelect={selectTab}
          />
        )}
        <div className={cx(tabStyles.tabs, tabStyles.tabs_3)}>
          <div
            className={cx(tabStyles.tab, tabActive.key == 'project_moon_build' ? tabStyles.on : '')}
            onClick={() => setTabActive({ key: 'project_moon_build', value: 'Deadrop Snapshots' })}
          >
            <span className={tabStyles.tab_name}>Deadrop Snapshots</span>
          </div>
          <div className={tabStyles.edge} />
          <div
            className={cx(tabStyles.tab, tabActive.key == 'deadrop_founder_builds' ? tabStyles.on : '')}
            onClick={() => setTabActive({ key: 'deadrop_founder_builds', value: 'Deadrop Founder Builds' })}
          >
            <span className={tabStyles.tab_name}>Deadrop Founder Builds</span>
          </div>
          <div className={tabStyles.edge} />
          <div
            className={cx(tabStyles.tab, tabActive.key == 'visor_cortex_db' ? tabStyles.on : '')}
            onClick={() => setTabActive({ key: 'visor_cortex_db', value: 'Visor Cortex Database' })}
          >
            <span className={tabStyles.tab_name}>Visor Cortex Database</span>
          </div>
        </div>
        <div className={tabStyles.body}>
          <div
            className={
              'relative sm:px-12 sm:py-[70px] md:px-20 lg:px-[140px] xl:px-[260px] ' +
              (tabActive.key == 'project_moon_build' ? 'block' : 'hidden')
            }
          >
            <ProjectMoon />
          </div>
          <div
            className={
              'relative sm:px-12 sm:py-[70px] md:px-20 lg:px-[140px] xl:px-[260px] ' +
              (tabActive.key == 'deadrop_founder_builds' ? 'block' : 'hidden')
            }
          >
            <FounderBuild />
          </div>
          <div
            className={
              'relative sm:px-12 sm:py-10 xl:px-[74px] ' + (tabActive.key == 'visor_cortex_db' ? 'block ' : 'hidden ')
            }
          >
            <VisorCortexDatabase />
          </div>
        </div>
      </div>
    </Element>
  )
}
